import classes from "../Styling/SharedStyling.module.css";

import React from "react";
import { Outlet, NavLink } from "react-router-dom";

function getClassName(isActive: boolean)
{
  return isActive ? classes.linkElementActive : classes.linkElement
}

const Layout = () => {

  return (
    <div>
      <nav className={classes.headerBar} id="navbar">
        <NavLink className={({ isActive }) => getClassName(isActive)} to="/">home</NavLink>
        <NavLink className={({ isActive }) => getClassName(isActive)} to="/apps">apps</NavLink>
        <a href="https://kylekeirstead.substack.com" target={"_blank"}>substack</a>
        <a href="https://twitter.com/KyleKeirstead" target={"_blank"}>x</a>
        <a href="https://www.youtube.com/@KyleKeirstead" target={"_blank"}>youtube</a>
      </nav>

      <Outlet />
    </div>
  )
};

export default Layout;